var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.0327C18.334 5.92302 18.313 5.81431 18.2715 5.71277C18.23 5.61124 18.1689 5.5189 18.0917 5.44103L14.5583 1.9077C14.4805 1.83046 14.3881 1.76936 14.2866 1.72789C14.1851 1.68642 14.0763 1.6654 13.9667 1.66603C13.857 1.6654 13.7483 1.68642 13.6467 1.72789C13.5452 1.76936 13.4529 1.83046 13.375 1.9077L11.0167 4.26603L1.90834 13.3744C1.8311 13.4522 1.77 13.5446 1.72853 13.6461C1.68706 13.7476 1.66604 13.8564 1.66667 13.966V17.4994C1.66667 17.7204 1.75447 17.9323 1.91075 18.0886C2.06703 18.2449 2.27899 18.3327 2.5 18.3327H6.03334C6.14994 18.339 6.26658 18.3208 6.37569 18.2792C6.48479 18.2375 6.58393 18.1734 6.66667 18.091L15.725 8.9827L18.0917 6.66603C18.1677 6.58526 18.2297 6.49231 18.275 6.39103C18.283 6.3246 18.283 6.25745 18.275 6.19103C18.2789 6.15224 18.2789 6.11315 18.275 6.07436L18.3333 6.0327ZM5.69167 16.666H3.33334V14.3077L11.6083 6.0327L13.9667 8.39103L5.69167 16.666ZM15.1417 7.21603L12.7833 4.8577L13.9667 3.6827L16.3167 6.0327L15.1417 7.21603Z",
    fill: "#342A0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.e4bfe7bc4f290b9d0406c133c3df960d.svg";
export { ForwardRef as ReactComponent };